type CreateLink = (fileId: number) => Promise<{ url: string }>;

// Fetch the file as a blob and download it via a same-origin object URL. A
// cross-origin href ignores the `download` attribute and, with target=_blank,
// opens a new tab per file — after the awaited createLink the popup blocker then
// kills every download after the first. A blob: URL is same-origin, so the
// download attribute works and no tab is opened, which makes bulk downloads work.
export async function downloadViaAnchor(createLink: CreateLink, fileId: number, fileName?: string) {
  const link = await createLink(fileId);
  const response = await fetch(link.url);
  if (!response.ok) {
    throw new Error(`Failed to fetch file for download (status ${response.status})`);
  }
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = fileName || 'download';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}
